export default "__VITE_PUBLIC_ASSET__efd44c9f__"